import moment from 'moment';
import constants from '@/constants/app.properties';

export const getFormattedDate = (value = '', format = constants.DATE_FORMAT) => (value ? moment(value).format(format) : '');
export const addDays = (value, count) => moment(value).add(count, 'days').format(constants.DATE_FORMAT);
export const defaultDateFormat = date => (date ? moment(date).format('ll') : '');
export const defaultTimeFormat = date => (date ? moment(date).format('HH:mm') : '');
export const getDaysFromNow = date => (date ? moment(date).fromNow() : '');
export const getDateFromNow = (date) => {
  if (date) {
    return moment(date).isBefore(moment) ? moment(date).format('MM-DD-YY, h:mm') : moment(date).format('HH:mm');
  }
  return '';
};
